import React from "react";
import SectionTitle2 from "../../components/SectionTitle/SectionTitle2";
import "./Contact.scss";
import Contact1 from "./Contact1";

const Contact = () => {
  return (

    <>
    
    <SectionTitle2 title="Contact Us" />
    
<Contact1 />
    </>
  );
};

export default Contact;
